import { login, getInfo, logout } from '@/api/auth'
import { getToken, removeToken, setToken } from '@/utils/auth'

const state = {
  token: getToken(),
  id: 0,
  name: '',
  username: '',
  isAdmin: false,
  role: null,
  permissionCodes: [],
  menus: []
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    const user = info && info.user ? info.user : info
    state.id = (user && Number(user.id)) || 0
    state.name = (user && (user.username || user.name)) || ''
    state.username = (user && user.username) || ''
    state.isAdmin = !!(user && user.is_admin)
    state.role = (info && info.role) || null
    state.permissionCodes = (info && (info.permission_codes || info.permissionCodes)) || []
    state.menus = (info && info.menus) || []
  },
  RESET_STATE(state) {
    state.token = ''
    state.id = 0
    state.name = ''
    state.username = ''
    state.isAdmin = false
    state.role = null
    state.permissionCodes = []
    state.menus = []
  }
}

const actions = {
  login({ commit }, userInfo) {
    return login(userInfo).then(data => {
      commit('SET_TOKEN', data.token)
      setToken(data.token)
      return data
    })
  },
  getInfo({ commit, state }) {
    return getInfo(state.token).then(info => {
      commit('SET_USER_INFO', info)
      return info
    })
  },
  logout({ commit }) {
    return logout()
      .catch(() => {})
      .finally(() => {
        removeToken()
        commit('RESET_STATE')
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
